module.exports = __webpack_public_path__ + "img/02rge.2349bfad.svg";